import { useMutation, useQuery } from 'react-query'
import {
  CreateFlexGroup,
  FlexGroup,
  FlexGroupGrid,
  FlexGroupMember,
  FlexGroupPagedQuery,
  FlexGroupUser,
  UpdateFlexGroup,
} from '../dtos'
import axios, { AxiosError, AxiosResponse } from 'axios'

const baseUrl = process.env.PUBLIC_URL
const apiUrl = process.env.REACT_APP_FLEX_GROUP_API
const url = `${baseUrl}/${apiUrl}`

export const useGetAll = (search: FlexGroupPagedQuery) => {
  return useQuery<AxiosResponse<FlexGroupGrid>, AxiosError>(
    ['flexGroups', search],
    () => axios.post<FlexGroupGrid>(`${url}/GetAllFlexGroups`, search),
    {},
  )
}

export const useGetByUserId = (userId: string) => {
  return useQuery<AxiosResponse<FlexGroupGrid>, AxiosError>(
    ['flexGroupByUserId', userId],
    () => axios.get<FlexGroupGrid>(`${url}/GetFlexGroupsByUserId?userId=${userId}`),
    {},
  )
}

export const useGetById = (flexGroupId: number) => {
  return useQuery(
    ['flexGroup', flexGroupId],
    () => axios.get<FlexGroup>(`${url}/GetById?flexGroupId=${flexGroupId}`),
    {},
  )
}

export const useAddFlexGroupMember = () => {
  return useMutation(
    (flexGroupMember: FlexGroupMember) =>
      axios.post<FlexGroupMember>(`${url}/AddFlexGroupMember`, flexGroupMember),
    {},
  )
}

export const useRemoveFlexGroupMember = () => {
  return useMutation(
    (flexGroupMember: FlexGroupMember) =>
      axios.post(`${url}/RemoveFlexGroupMember`, flexGroupMember),
    {},
  )
}

export const useAddFlexGroupUser = () => {
  return useMutation(
    (flexGroupUser: FlexGroupUser) => axios.post(`${url}/AddFlexGroupUser`, flexGroupUser),
    {},
  )
}

export const useRemoveFlexGroupUser = () => {
  return useMutation(
    (flexGroupUser: FlexGroupUser) => axios.post(`${url}/RemoveFlexGroupUser`, flexGroupUser),
    {},
  )
}

export const useCreate = () => {
  return useMutation(
    (flexGroup: CreateFlexGroup) => axios.post<FlexGroup>(`${url}/Create`, flexGroup),
    {},
  )
}

export const useUpdate = () => {
  return useMutation((flexGroup: UpdateFlexGroup) => axios.post(`${url}/Update`, flexGroup), {})
}
